export default {
    offerline: {
        name: 'offerline',
        id: 1,
        icon: 'el-icon-s-marketing',
        title: $t('integration.offline_analysis'),
        headerText: $t('integration.offline_analysis'),
        check: false,
        // 分析方法 method
        type: 1,
        // 日期类型  way
        dateType: '',
        // 值
        timeValue: '',
        timeType: 'year',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            }
        ]
    },

    powerout: {
        name: 'powerout',
        id: 2,
        icon: 'el-icon-connection',
        title: $t('integration.outage_analysis'),
        headerText: $t('integration.outage_analysis'),
        check: false,
        type: 1,
        timeValue: '',
        timeType: 'daterange',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            }
        ]
    },

    configure: {
        name: 'configure',
        id: 3,
        icon: 'el-icon-crop',
        title: $t('integration.configuration_analysis'),
        headerText: $t('integration.configuration_analysis'),
        check: false,
        type: 1,
        timeValue: '',
        timeType: 'daterange',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            }
        ]
    }
};
